<template>
  <v-container>
    <v-alert
      :type="alertType"
      transition="scale-transition"
      v-model="alertShow"
      border="left"
      dismissible
    >{{alertMsg}}</v-alert>
    <v-row>
      <v-col class="text-center">
        <v-btn-toggle
          v-if="choosenNetwork==null && choosenDeviceType==null && choosenDevice==null && choosenUser==null"
          v-model="active"
          color="primary"
        >
          <v-btn>
            <v-icon class="ma-1 mr-3" left>mdi-lan</v-icon>
            {{$t('Admin.networks')}}
          </v-btn>
          <v-btn>
            <v-icon class="ma-1 mr-3" left>mdi-folder-network</v-icon>
            {{$t('Admin.deviceTypes')}}
          </v-btn>
          <v-btn>
            <v-icon class="ma-1 mr-3" left>mdi-database</v-icon>
            {{$t('Admin.devices')}}
          </v-btn>
          <v-btn>
            <v-icon class="ma-1 mr-3" left>mdi-account</v-icon>
            {{$t('Admin.users')}}
          </v-btn>
        </v-btn-toggle>
      </v-col>
    </v-row>
    <allnetworks v-if="active==0  && choosenNetwork==null" @choosennetwork="showNetwork"></allnetworks>
    <alldevicesTypes
      v-if="active==1 && choosenDeviceType==null"
      @choosendeviceType="showDeviceType"
    ></alldevicesTypes>
    <alldevices v-if="active==2 && choosenDevice==null " @choosendevice="showDevice"></alldevices>
    <allusers v-if="active==3 && choosenUser==null" @choosenuser="showUser"></allusers>
    <network
      v-if="active==0 && choosenNetwork!=null"
      :choosenNetwork="choosenNetwork"
      :path="path"
      @back="back"
      @edit="editNetwork"
      @error="error"
      @saved="saved"
      @user="editUserInNetwork"
      @backinfo="backinfonetwork"
    ></network>
    <devicetype
      v-if="active==1 && choosenDeviceType!=null"
      :choosenDeviceType="choosenDeviceType"
      :path="path"
      @editDeviceType="editDeviceType"
      @createDeviceType="createDeviceType"
      @manageDataAndAlert="manageDataAndAlert"
      @updateMqtt="updateMqtt"
      @createMqtt="createMqtt"
      @updateAlert="updateAlert"
      @createAlert="createAlert"
      @back="back"
      @edit="editDeviceType"
      @error="error"
      @saved="saved"
      @user="editUserInDeviceType"
      @backinfo="backinfodevicetype"
      @backManage="backManageDeviceType"
      @alertSaved="alertSaved"
      @mqttSaved="mqttSaved"
      @clickmarker="clickmarker"
    ></devicetype>
    <device
      v-if="active==2 && choosenDevice!=null"
      @backnetwork="back"
      :choosenDevice="choosenDevice"
      :path="path"
      @createDeviceAlert="createDeviceAlert"
      @updateDeviceAlert="updateDeviceAlert"
      @alertSaved="alertSaved"
      @backDevice="backDevice"
      :choosenDeviceAlert="choosenDeviceAlert"
    ></device>
    <user
      v-if="active==3 && choosenUser!=null"
      :choosenUser="choosenUser"
      :path="path"
      @back="back"
    ></user>
    {{changedPath}}
  </v-container>
</template>

<script>
import AllNetworkComponent from "./AllNetworks";
import AllDeviceTypeComponent from "./AllDeviceTypes";
import AllDeviceComponent from "./AllDevices";
import AllUserComponent from "./AllUsers";

import NetworkComponent from "./ShowNetwork";
import DeviceTypeComponent from "./ShowDeviceType";
import DeviceComponent from "./ShowDevice";
import UserComponent from "./ShowUser";

export default {
  components: {
    allnetworks: AllNetworkComponent,
    alldevicesTypes: AllDeviceTypeComponent,
    alldevices: AllDeviceComponent,
    allusers: AllUserComponent,
    network: NetworkComponent,
    devicetype: DeviceTypeComponent,
    device: DeviceComponent,
    user: UserComponent,
  },
  props: {
    admin: Boolean,
    changedPath: String,
  },
  data() {
    return {
      active: 0,
      alertShow: false,
      alertMsg: "",
      alertType: "success",
      choosenNetwork: null,
      choosenDeviceType: null,
      choosenDevice: null,
      choosenUser: null,
      path: "",
      choosenDeviceAlert: null,
    };
  },
  watch: {
    changedPath: function (value) {
      switch (value) {
        case "admin":
          this.back();
          break;
        case "adminNetInfo":
          this.backinfonetwork();
          break;
        case "adminDevTypeInfo":
          this.backinfodevicetype();
          break;
        case "adminManageDataAndAlert":
          this.backManageDeviceType();
          break;
        case "adminDeviceInfo":
          this.backDevice();
          break;
        case "adminUserInfo":
          //
          break;
      }
    },
    choosenNetwork: function () {
      if (this.choosenNetwork) {
        this.choosenNetwork.networkId = this.choosenNetwork.id;
        this.choosenNetwork.scopes = ["admin"];
      }
    },
    choosenDeviceType: function () {
      if (this.choosenDeviceType) {
        this.choosenDeviceType.deviceTypeId = this.choosenDeviceType.id;
        this.choosenDeviceType.scopes = ["admin"];
      }
    },
  },
  methods: {
    updateDeviceAlert(alert) {
      this.choosenDeviceAlert = alert;
      this.$emit("subpath", [
        { name: this.choosenDevice.name, subpath: "adminDeviceInfo" },
        {
          name: "Alert (" + alert.name + ")",
          subpath: "updateAlert",
        },
      ]);
    },
    createDeviceAlert() {
      this.choosenDeviceAlert = {};
      this.$emit("subpath", [
        { name: this.choosenDevice.name, subpath: "adminDeviceInfo" },
        {
          name: this.$t("DataHome.createDeviceAlert"),
          subpath: "createAlert",
        },
      ]);
    },
    updateMqtt(mqtt) {
      this.path = "updateMqtt";
      this.$emit("subpath", [
        { name: this.choosenDeviceType.name, subpath: "adminDevTypeInfo" },
        {
          name: mqtt.url + ":" + mqtt.port,
          subpath: "updateMqtt",
        },
      ]);
    },
    createMqtt() {
      this.path = "createMqtt";
      this.$emit("subpath", [
        { name: this.choosenDeviceType.name, subpath: "adminDevTypeInfo" },
        {
          name: this.$t("DeviceTypes.createMqtt"),
          subpath: "createMqtt",
        },
      ]);
    },
    updateAlert(alert) {
      this.path = "updateAlert";
      this.$emit("subpath", [
        { name: this.choosenDeviceType.name, subpath: "adminDevTypeInfo" },
        {
          name: this.$t("DeviceTypes.manageDataAndAlert"),
          subpath: "adminManageDataAndAlert",
        },
        {
          name: alert.name,
          subpath: "updateAlert",
        },
      ]);
    },
    createAlert() {
      this.path = "createAlert";
      this.$emit("subpath", [
        { name: this.choosenDeviceType.name, subpath: "adminDevTypeInfo" },
        {
          name: this.$t("DeviceTypes.manageDataAndAlert"),
          subpath: "adminManageDataAndAlert",
        },
        {
          name: this.$t("DeviceTypes.createAlert"),
          subpath: "createAlert",
        },
      ]);
    },
    createDeviceType: function () {
      this.path = "create";
      this.$emit("subpath", [
        { name: this.$t("DeviceTypes.create"), subpath: "create" },
      ]);
    },
    manageDataAndAlert: function () {
      this.path = "manageDataAndAlert";
      this.$emit("subpath", [
        { name: this.choosenDeviceType.name, subpath: "adminDevTypeInfo" },
        {
          name: this.$t("DeviceTypes.manageDataAndAlert"),
          subpath: "adminManageDataAndAlert",
        },
      ]);
    },
    showNetwork: function (value) {
      this.choosenNetwork = value;
      this.path = "info";
      this.$emit("subpath", [
        { name: this.choosenNetwork.name, subpath: "adminNetInfo" },
      ]);
    },
    showDeviceType: function (value) {
      this.choosenDeviceType = value;
      this.path = "info";
      this.$emit("subpath", [
        { name: this.choosenDeviceType.name, subpath: "adminDevTypeInfo" },
      ]);
    },
    showDevice: function (value) {
      this.choosenDevice = value;
      this.path = "info";
      this.$emit("subpath", [
        { name: this.choosenDevice.name, subpath: "adminDeviceInfo" },
      ]);
    },
    showUser: function (value) {
      this.choosenUser = value;
      this.path = "info";
      this.$emit("subpath", [
        { name: this.choosenUser.username, subpath: "adminUserInfo" },
      ]);
    },
    back: function () {
      this.path = "";
      this.choosenNetwork = null;
      this.choosenDeviceType = null;
      this.choosenDevice = null;
      this.choosenUser = null;
      this.$emit("subpath", [""]);
    },
    backDevice: function () {
      this.path = "info";
      this.choosenDeviceAlert = null;
      this.$emit("subpath", [
        { name: this.choosenDevice.name, subpath: "adminDeviceInfo" },
      ]);
    },
    backinfonetwork: function () {
      this.path = "info";
      this.$emit("subpath", [
        { name: this.choosenNetwork.name, subpath: "adminNetInfo" },
      ]);
    },
    backinfodevicetype: function () {
      this.path = "info";
      this.$emit("subpath", [
        { name: this.choosenDeviceType.name, subpath: "adminDevTypeInfo" },
      ]);
    },
    editNetwork: function () {
      this.path = "edit";
      this.$emit("subpath", [
        { name: this.choosenNetwork.name, subpath: "adminNetInfo" },
        {
          name: this.$t("Networks.edit"),
          subpath: "edit",
        },
      ]);
    },
    backManageDeviceType: function () {
      this.path = "manageDataAndAlert";
      this.$emit("subpath", [
        { name: this.choosenDeviceType.name, subpath: "adminDevTypeInfo" },
        {
          name: this.$t("DeviceTypes.manageDataAndAlert"),
          subpath: "adminManageDataAndAlert",
        },
      ]);
    },
    editUserInNetwork: function () {
      this.path = "manageUser";
      this.$emit("subpath", [
        { name: this.choosenNetwork.name, subpath: "adminNetInfo" },
        {
          name: this.$t("Networks.manage"),
          subpath: "manageUser",
        },
      ]);
    },
    editDeviceType: function () {
      this.path = "edit";
      this.$emit("subpath", [
        { name: this.choosenDeviceType.name, subpath: "adminDevTypeInfo" },
        {
          name: this.$t("DeviceTypes.edit"),
          subpath: "edit",
        },
      ]);
    },
    editUserInDeviceType: function () {
      this.path = "manageUser";
      this.$emit("subpath", [
        { name: this.choosenDeviceType.name, subpath: "adminDevTypeInfo" },
        {
          name: this.$t("DeviceTypes.manage"),
          subpath: "manageUser",
        },
      ]);
    },
    alertSaved: function (value) {
      this.alertMsg = value;
      this.alertType = "success";
      this.alertShow = true;
      this.path = "manageDataAndAlert";
      this.$emit("subpath", [
        { name: this.choosenDeviceType.name, subpath: "adminDevTypeInfo" },
        {
          name: this.$t("DeviceTypes.manageDataAndAlert"),
          subpath: "adminManageDataAndAlert",
        },
      ]);
      window.scrollTo(0, 0);
    },
    mqttSaved: function (value) {
      this.alertMsg = value;
      this.alertType = "success";
      this.alertShow = true;
      this.path = "info";
      this.$emit("subpath", [
        { name: this.choosenDeviceType.name, subpath: "adminDevTypeInfo" },
      ]);
      window.scrollTo(0, 0);
    },
    clickmarker: function (value) {
      this.$emit("clickmarker", value);
    },
    error: function (value) {
      this.alertMsg = value;
      this.alertType = "error";
      this.alertShow = true;
    },
    saved: function (value) {
      this.alertMsg = value;
      this.alertType = "success";
      this.alertShow = true;
      this.path = "";
      this.choosenNetwork = null;
      this.choosenDeviceType = null;
      this.choosenDevice = null;
      this.choosenUser = null;
      this.choosenDeviceAlert = null;
      this.$emit("subpath", [""]);
    },
  },
};
</script>


